import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { UsersApi } from '@shared/api/rest';
import type { AddUserAccountsRequest, UserProfileResponse } from '@shared/api/rest/users';

const effect = createEffect((request: AddUserAccountsRequest) => UsersApi.addUserAccounts(request));
const clearEvent = createEvent();

const $dataStore = createStore<UserProfileResponse | null>(null)
  .on(effect.done, (current, values) => values.result.data || current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, () => false)
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(effect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $addUserAccountsStore = {
  events: {
    add: effect,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
